module.exports = __webpack_public_path__ + "static/img/アセット 63@3x.b40df85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 63@3x.png
// module id = PvZQ
// module chunks = 1